import {createSelector} from 'reselect';
import {getExperiment} from '../../ExperimentSelectors';

export default createSelector(
  [getExperiment],
  experiment => experiment?.apm_redesign_wave_02 === 'v3|checkout_btn_non_sticky_and_hide_payment_icons',
);
